import { LayoutItem } from '../interfaces';

/**
 * Layout: English
 */
export default <LayoutItem>{
  layout: [
    'q w e r t y u i o p',
    'a s d f g h j k l',
    '- z x c v b n m {bksp}',
  ],
  name: 'english',
};
